import React from 'react';
import { Stack, Typography } from '@mui/material';
import { Payments } from '@mui/icons-material';

export const PartialPaymentAllowedPill = (): JSX.Element => (
  <Stack
    data-testid="partial-payment-allowed-pill"
    direction="row"
    spacing={0.5}
    alignItems="center"
    sx={{ mt: 0.5 }}
  >
    <Payments sx={{ fontSize: 14, color: 'grey.600' }} />
    <Typography>Partial payment allowed</Typography>
  </Stack>
);
